/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Aggregation function applied when rolling a field up over a zone.
 */
export var AggFunc;
(function (AggFunc) {
    AggFunc["SUM"] = "SUM";
    AggFunc["AVG"] = "AVG";
    AggFunc["MIN"] = "MIN";
    AggFunc["MAX"] = "MAX";
    AggFunc["COUNT"] = "COUNT";
})(AggFunc || (AggFunc = {}));
